import {getPath} from '@epic-core/common';
import {getLocalePath} from 'epic-ue-locale-mode';
import React from 'react';
import {Redirect} from './Redirect';
import {ServerRoute} from './routes';

const StatusRedirect = (): JSX.Element => {
    return <Redirect url="https://status.epicgames.com" status={301} />;
};
const FanArtRedirect = (): JSX.Element => {
    return (
        <Redirect url="https://legal.epicgames.com/:locale/epicgames/fan-art-policy" status={301} />
    );
};
const CustomerSupportRedirect = (): JSX.Element => {
    return <Redirect to="/customer-service" status={301} />;
};
const AboutRedirect = (): JSX.Element => {
    return <Redirect to="/about" status={301} />;
};

export const getAppRedirects = (): ServerRoute[] => {
    const path = getPath();
    const localePath = getLocalePath();

    return [
        {
            path: `${localePath}`,
            element: <Redirect to="/home" status={301} />
        },
        {
            path: `${localePath}/feed`,
            element: <Redirect to="/news" status={301} />
        },
        {
            path: `${localePath}/feed/news`,
            element: <Redirect to="/news" status={301} />
        },
        {
            path: `${localePath}/fortnite-mega-drop-faq`,
            element: <Redirect to="/free-fortnite-faq" status={301} />
        },
        {
            path: `${localePath}/status`,
            element: <StatusRedirect />
        },
        {
            path: `${path}/status`,
            element: <StatusRedirect />
        },
        {
            path: `${localePath}/about/fan-site-policy`,
            element: <FanArtRedirect />
        },
        {
            path: `${localePath}/fan-site-policy`,
            element: <FanArtRedirect />
        },
        {
            path: `${localePath}/about/fan-art-policy`,
            element: <FanArtRedirect />
        },
        {
            path: `${localePath}/help`,
            element: <CustomerSupportRedirect />
        },
        {
            path: `${localePath}/account-help`,
            element: <CustomerSupportRedirect />
        },
        {
            path: `${localePath}/account-security`,
            element: (
                <Redirect
                    url="https://safety.epicgames.com/:locale/policies/account-security"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/about/faq`,
            element: <AboutRedirect />
        },
        {
            path: `${localePath}/about/contact`,
            element: <AboutRedirect />
        },
        {
            path: `${localePath}/community`,
            element: <Redirect to="/home" status={301} />
        },
        {
            path: `${localePath}/freefortnite-uk`,
            element: <Redirect to="/freefortnite-uk-press-release" status={301} />
        },
        {
            path: `${localePath}/epic-rewards-faq`,
            element: (
                <Redirect url="https://store.epicgames.com/features/epic-rewards" status={301} />
            )
        },
        {
            path: `${localePath}/students`,
            element: <Redirect to="/earlycareers" status={301} />
        },
        {
            path: `${localePath}/students/career-paths`,
            element: <Redirect to="/earlycareers/career-paths" status={301} />
        },
        {
            path: `${localePath}/parental-controls`,
            element: <Redirect url="https://safety.epicgames.com/parental-controls" status={302} />
        },
        {
            path: `${localePath}/usk-imprint`,
            element: <Redirect to="/impressum" status={301} />
        },
        {
            path: `${localePath}/wallet-faq`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/account-balance-faq"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/account-balance-faq`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/account-balance-faq"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/community-rules`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/community-rules"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/marketplace-disclosure-requirements`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/marketplace-disclosure-requirements"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/parental-consent`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/parental-consent"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/privacynotice`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/privacy-policy"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/privacypolicy`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/privacy-policy"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/fan-art-policy`,
            element: <FanArtRedirect />
        },
        {
            path: `${localePath}/content-guidelines`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/content-guidelines"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/right-of-withdrawal`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/right-of-withdrawal"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/tos`,
            element: (
                <Redirect url="https://legal.epicgames.com/:locale/epicgames/tos" status={301} />
            )
        },
        {
            path: `${localePath}/tou`,
            element: (
                <Redirect url="https://legal.epicgames.com/:locale/epicgames/tos" status={301} />
            )
        },
        {
            path: `${localePath}/store-refund-policy`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/store/refund-policy"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/wallet-terms`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/account-balance-terms"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/account-balance-terms`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/account-balance-terms"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/giftcardterms`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/gift-card-terms"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/gift-card-terms`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/:locale/epicgames/gift-card-terms"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/payments-act`,
            element: (
                <Redirect
                    url="https://legal.epicgames.com/ja/epicgames/payments-act"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/authenticator`,
            element: <Redirect url="https://store.epicgames.com/:locale/mobile" status={301} />
        },
        {
            path: `${localePath}/affiliate/*`,
            element: <Redirect url="https://sac.epicgames.com/" status={301} />
        }
    ];
};
